// extracted by mini-css-extract-plugin
module.exports = {"author-content":"author_author-content__ZggGd"};